<div class="wrapper">
  <div id="rotationalSpeedChart" [ngClass]="{'special': (showPlaceholder$ | async)}" #rotationalSpeedChart></div>
  @if ((showPlaceholder$ | async)) {
    <div class="placeholder">
      <p>Rotational speed graph</p>
      <mat-progress-spinner mode="indeterminate" [diameter]="50"></mat-progress-spinner>
    </div>
  }
</div>